import { render } from "./Select2Component.vue?vue&type=template&id=e5de6cf6"
import script from "./Select2Component.vue?vue&type=script&lang=js"
export * from "./Select2Component.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/dev.soft.team/www/autoringen/autoringen.dev.soft.team/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/themes/default/js/components/Select2Component.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e5de6cf6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e5de6cf6', __exports__)) {
    console.log('reload')
    api.reload('e5de6cf6', __exports__)
  }
  
  module.hot.accept("./Select2Component.vue?vue&type=template&id=e5de6cf6", () => {
    console.log('re-render')
    api.rerender('e5de6cf6', render)
  })

}


export default __exports__